import { render, staticRenderFns } from "./index.vue?vue&type=template&id=894bf2cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=894bf2cc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894bf2cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('894bf2cc')) {
      api.createRecord('894bf2cc', component.options)
    } else {
      api.reload('894bf2cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=894bf2cc&scoped=true", function () {
      api.rerender('894bf2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/plugin/index.vue"
export default component.exports